import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import DynamicForm from "@/components/site/DynamicForm";

export default function SubmitResume() {
  const [content, setContent] = useState(null);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/content").then((r) => setContent(r.data)).catch(() => {}); }, []);
  const fc = content?.forms?.resume || {};
  const fields = content?.form_builder?.resume || [];

  const submit = async (values, files) => {
    setLoading(true);
    try {
      const fd = new FormData();
      Object.entries(values).forEach(([k, v]) => fd.append(k, v));
      Object.entries(files).forEach(([k, file]) => fd.append(k === "resume" ? "resume" : k, file));
      if (!fd.has("resume")) { toast.error("Please upload your resume"); setLoading(false); return; }
      await api.post("/apply", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setDone(true);
      toast.success("Application submitted! Check your email for confirmation.");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail) || "Submission failed"); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <Header />
      <section className="bg-navy text-white py-16">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white mb-4"><ArrowLeft size={16} /> Back to Home</Link>
          <h1 className="font-display font-bold text-4xl tracking-tight">{fc.title || "Submit Your Resume"}</h1>
          <p className="mt-3 text-slate-300">{fc.subtitle || "Join our talent network. Share your profile and we'll match you with the right opportunities."}</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          {done ? (
            <div data-testid="resume-success" className="bg-white rounded-2xl border border-slate-200 p-10 text-center">
              <CheckCircle2 className="mx-auto text-emerald-brand" size={56} />
              <h2 className="mt-4 font-display font-semibold text-2xl text-navy">{fc.success_title || "Application Received!"}</h2>
              <p className="mt-2 text-slate-600">{fc.success_message || "Thank you for applying. We've sent a confirmation to your email and will reach out if there's a match."}</p>
              <Link to="/" className="inline-block mt-6 bg-emerald-brand text-white font-semibold rounded-full px-6 py-3 hover:bg-emerald-dark transition-colors">Back to Home</Link>
            </div>
          ) : (
            content && <DynamicForm fields={fields} onSubmit={submit} loading={loading} submitLabel={fc.submit_label || "Submit Application"} testid="resume-form" />
          )}
        </div>
      </section>
      <Footer content={content} />
    </div>
  );
}
